import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { FormattedMessage, useIntl } from 'react-intl';
import Heading from '../../common/Heading';
import InfoBox from '../../common/InfoBox';
import { TextInput } from '../../common/FormFields';
import formStyles from '../../styles/forms.module.scss';
import commonStyles from './StepWindFacilityData.module.scss';
import s from './StepLargeSolarFacilityData.module.scss';

function StepLargeSolarFacilityData(props) {
  const { isSolarFacilitySoldOut } = props;

  const intl = useIntl();

  const linkToVerbundHome =
    intl.locale === 'en'
      ? 'https://www.verbund.com/en-at'
      : 'https://www.verbund.com/de-at';

  return (
    <section className={commonStyles.stepBioMasseFacilityData}>
      <Heading level={2} className={`${commonStyles.heading}`}>
        <FormattedMessage id="offerWizard.StepSomeInformation.title" />
      </Heading>
      <div className={formStyles.formFields}>
        <div className={formStyles.inputPair}>
          <Field
            name="largeSolarFacilityData.sizeOfArea"
            component={TextInput}
            labelMsg="offerWizard.stepLargeSolarFacilityData.sizeOfArea.label"
          />
          <Field
            name="largeSolarFacilityData.consumption"
            component={TextInput}
            labelMsg="offerWizard.stepLargeSolarFacilityData.consumption.label"
          />
        </div>
      </div>
      <div role="alert">
        {isSolarFacilitySoldOut && (
          <InfoBox>
            <Heading level={4}>
              <FormattedMessage id="offerWizard.stepLargeSolarFacilityData.soldOut.title" />
            </Heading>
            <p className={s.soldOutText}>
              <FormattedMessage id="offerWizard.stepLargeSolarFacilityData.soldOut.text1" />
              <a href={linkToVerbundHome}>
                <FormattedMessage id="offerWizard.stepLargeSolarFacilityData.soldOut.text2" />
              </a>
              <FormattedMessage id="offerWizard.stepLargeSolarFacilityData.soldOut.text3" />
            </p>
          </InfoBox>
        )}
      </div>
    </section>
  );
}

StepLargeSolarFacilityData.propTypes = {
  isSolarFacilitySoldOut: PropTypes.bool.isRequired,
};

export default StepLargeSolarFacilityData;
